<template>
  <div class="products">
    <v-row>
      <v-col
        cols="12"
        sm="6"
        md="4"
        lg="4"
        v-for="(set, index) in set1"
        :key="index"
      >
        <v-card class="mx-auto" router :to="set.router">
          <v-list-item three-line>
            <v-avatar class="mr-4" tile width="150" height="200" color="grey">
              <v-img :src="set.img"></v-img>
            </v-avatar>
            <v-list-item-content>
              <div class="overline mb-1">
                <span>Alphyiago</span>
                <span><v-icon size="15" color="red">mdi-heart</v-icon></span>
              </div>
              <v-list-item-title class="headline mb-1" v-text="set.title" />
              <v-list-item-title class="body-1 font-weight-medium mb-1">
                <span class="was-price" v-text="set.price1" />&nbsp;
                <span v-text="set.price2" />
              </v-list-item-title>
              <v-list-item-subtitle
                >Available in all sizes
              </v-list-item-subtitle>
              <div class="rating">
                <v-row align="center" class="mx-0">
                  <v-rating
                    :value="set.rating"
                    color="green"
                    dense
                    half-increments
                    readonly
                    size="14"
                  ></v-rating>
                  <div class="grey--text ml-4">{{ set.rating }}</div>
                </v-row>
              </div>
            </v-list-item-content>
          </v-list-item>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      set1: [
        {
          title: 'Tracksuites',
          img: '/img/products/img1.jpg',
          price1: 'R 799.99',
          price2: 'R 699.99',
          rating: '4.0',
        },
        {
          title: 'Swearters',
          router: '/sweaters',
          img: '/img/products/img2.jpg',
          price1: '',
          price2: 'R 350.00',
          rating: '4.5',
        },
        {
          title: 'Jackets',
          router: '/jackets',
          img: '/img/products/img3.jpg',
          price1: '',
          price2: 'R 799.99',
          rating: '4.5',
        },
        {
          title: 'T-shirts',
          img: '/img/products/img4.jpg',
          price1: 'R 250. 00',
          price2: 'R 180.00',
          rating: '3.5',
        },
        {
          title: 'Jean Jackets',
          img: '/img/products/img5.jpg',
          price1: '',
          price2: 'R 499.99',
          rating: '5.0',
        },
        {
          title: 'Tracksuites',
          img: '/img/products/img6.jpg',
          price1: 'R 999.99',
          price2: 'R 850.00',
          rating: '4.0',
        },
      ],
    }
  },
}
</script>